import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled(Stack)`
  width: 100%;
  height: 100%;
`;
